module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "empty-folder.a877d856.svg";